module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAAwCAMAAABtwnnyAAAAPFBMVEXVCAz////wqKncNDfhTlHgSk3++PjfQEP//Pz98/P0v8Dri43mbnDiVFb65OT409TvoaPmamzaIyfXFxqZAYYAAAAAY0lEQVRIx+3ROQ6AMAxEUUyAAAn7/e+KhCUsUWXcIMH8zsVrPBVjL9SsLtVJcimR7FLST7C6GiKs1AVUafOOKGs5EGWNkLJqSFkJUlbGVcnssdW2+x96F64enu8gI/sVY9/sBGK6AvyKXSYtAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/r-c-2.png
// module id = o2Im
// module chunks = 1